import React, {useContext} from 'react';
import {Arguments} from '../common/Arguments';
import {Col, Form, Input, InputNumber, message, Row, Select} from 'antd';
import {GetApiMethod, PostToJava} from '../common/ApiMethod';
import {validateWhiteSpace} from '../common/ValidateWhiteSpace';
import SaveButtonComponent from '../common/SaveButtonComponent';
import {getFirstLetters} from '../common/ConversionMethod';
import {sideMenuContext} from '../../../router/IndexRouter';

const layout = {
	labelCol: {span: 8},
	wrapperCol: {span: 16},
};

const tailLayout = {
	wrapperCol: {offset: 4, span: 16},
};
// 向用户中心注册用户，成功后再向 user_info 表中添加用户
const AddUser = () => {
	const {setDataSource, setCopyDataSource} = useContext(sideMenuContext);
	const checkLoginUser = Arguments.host + '/society_organization/policy/api!getLoginUser.do';
	const registerUrl = Arguments.host + '/society_organization/changePassword/api!userRegister.do';
	const getApi = Arguments.host + '/society_organization/policy/api!allUsers.do';
	const [form] = Form.useForm();
	const registerOneUser = (data) => {
		// 首先验证用户是否已经存在
		const charUsername = getFirstLetters(data.nickname);
		PostToJava(checkLoginUser, {username: charUsername}).then(res => {
			if (res?.data.code === 1 && res?.data.result.data.resultList.length > 0) {
				message.warn('当前用户已经存在');
			} else {
				// 其次向用户中心发送新增用户的请求，充分利用用户中心的注册管理机制确保安全
				const ObjData = {
					userName: charUsername,
					password: '123qweAS',
					nickname: data.nickname,
					phoneNumber: data.phoneNumber,
					organizationName: data.nickname,
					role: data.role,
				};
				PostToJava(registerUrl, {...data, ...ObjData}).then(res => {
					if (res?.data.code === 1 || res?.data.code === '1') {
						// 接口中包括了向 user_info 和 organization_info 表中新增数据
						message.success('新增用户成功');
						setTimeout(() => {
							setDataSource([]);
							GetApiMethod({getApi, setDataSource, setCopyDataSource});
						}, 500);
					} else {
						message.error('操作失败：' + res?.data.result);
					}
				});
			}
		});
	};

	return (
		<Form
			{...layout}
			form={form}
			name="control-hooks"
			onFinish={registerOneUser}
			style={{maxWidth: 1200, marginLeft: 40}}
		>
			<Row align="top">
				<Col span={12}>
					<Form.Item name="nickname" label="用户名"
							   rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input placeholder={'为避免重名，请使用全称'}/>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item name="password" label="登录密码">
						<Input disabled={true} placeholder={'初始密码为：123qweAS，后续可根据需要修改'}/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item
						name="role"
						label="角色"
						rules={[{required: true, message: '内容不能为空'}]}
						initialValue="社会组织管理员"
					>
						<Select>
							<Select.Option value="社会组织管理员">社会组织管理员</Select.Option>
							<Select.Option value="民非组织管理员">民非组织管理员</Select.Option>
							<Select.Option value="基金会">基金会</Select.Option>
						</Select>
					</Form.Item>
				</Col>
				<Col span={12}>
					<Form.Item
						name="phoneNumber" label="手机号"
						rules={[{required: true, validator: validateWhiteSpace}]}>
						<Input/>
					</Form.Item>
				</Col>
			</Row>

			<Row align="top">
				<Col span={12}>
					<Form.Item
						name="showFlag" label="显示序号" rules={[{required: true, message: '内容不能为空'}]}>
						<InputNumber min={0} style={{width: 150}}/>
					</Form.Item>
				</Col>
			</Row>

			<Form.Item {...tailLayout}>
				<SaveButtonComponent/>
			</Form.Item>
		</Form>
	);
};

export default AddUser;
